var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 24H37.5V27H36C34.35 27 33 28.35 33 30V33C33 34.65 34.35 36 36 36H42V39H33V42H37.5V45H40.5V42H42C43.65 42 45 40.65 45 39V36C45 34.35 43.65 33 42 33H36V30H45V27H40.5V24ZM42 12H33V6C33 4.35 31.65 3 30 3H18C16.35 3 15 4.35 15 6V12H6C4.35 12 3 13.35 3 15V36C3 37.65 4.35 39 6 39H28.5V36H6V15H42V21H45V15C45 13.35 43.65 12 42 12ZM30 12H18V6H30V12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPortfolio);
export default __webpack_public_path__ + "static/media/ic-portfolio.b19516ff703cb4542c8b7dcde2165d7e.svg";
export { ForwardRef as ReactComponent };